import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoMdArrowDropdown } from "react-icons/io";

const FormTypes = ({ setFormType, type }) => {
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [languageName, setLanguageName] = useState(type || 'Individual'); // Default to 'Individual' if type is not provided
    const navigate = useNavigate();

    const toggleDropdown = () => {
        setDropdownVisible(!dropdownVisible);
    };

    const languageSelectHandler = (lang) => {
        setLanguageName(lang);
        setFormType(lang);
        
        if (lang === 'Corporate') {
            navigate(`${process.env.PUBLIC_URL}/corporateForm`);
            setLanguageName(lang);
        } else {
            navigate(`${process.env.PUBLIC_URL}/`);
        }
    };

    return (
        <div className={`dropdown`}>
            <button onClick={toggleDropdown} className={`dropbtn text-center`}>
                {languageName}
                <IoMdArrowDropdown />
            </button>
            {dropdownVisible && (
                <div id="myDropdown1" className="dropdown-content">
                    <div className='d-flex align-items-center justify-content-center' onClick={() => { languageSelectHandler('Individual'); toggleDropdown() }}>
                        Individual
                    </div>
                    <div className='d-flex aling-items-center justify-content-center' onClick={() => { languageSelectHandler('Corporate'); toggleDropdown() }}>
                        Corporate
                    </div>
                </div>
            )}
        </div>
    )
}

export default FormTypes
